import { useCallback } from 'react';
import { type LocaleCode, useLocaleCode } from '../../i18n';

type FormatLocalizedNumberProperties = {
  localeCode?: LocaleCode;
  numberFormatProperties?: Intl.NumberFormatOptions;
  value?: null | number | string;
};

export const useFormatLocalizedNumber = () => {
  const locale = useLocaleCode();

  return useCallback(
    ({ localeCode, numberFormatProperties, value }: FormatLocalizedNumberProperties) => {
      if (value === null || (typeof value === 'string' && value.trim() === '') || Number.isNaN(Number(value))) {
        return '';
      }

      const maximumFractionDigits =
        numberFormatProperties?.maximumFractionDigits ??
        Math.max(2, numberFormatProperties?.minimumFractionDigits ?? 0);

      return new Intl.NumberFormat(localeCode ?? locale, {
        ...numberFormatProperties,
        maximumFractionDigits,
      }).format(Number(value));
    },
    [locale],
  );
};
